<template>
    <div class="c-message" :class="{'c-message_interviewer': user.id != message.user_id}">
        <div class="c-message__intro">
            <span class="c-message__name" v-html="userName" v-if="message.user.doctor || !consultation.anonym"></span>
            <span class="c-message__name" v-else>Аноним</span>
            <time class="c-message__time" v-html="createdAt"></time>
        </div>
        <div class="c-message__body" v-html="$options.filters.lineBreak(message.text)"></div>
    </div>
</template>

<script>
	import {mapState} from 'vuex';

    import dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';

    dayjs.extend(utc);

    export default {
        name: 'Message',
		props: {
			message: {
				type: Object,
				required: true
			},
		},
		computed: {
			...mapState([
				'user',
                'consultation',
                'patient'
			]),
            createdAt() {
                return dayjs.createFromTimezone(this.message.created_at, this.user.time_zone).format('YYYY-MM-DD HH:mm');
            },
            userName(){
                return this.message.user.doctor ? this.message.user.title : this.patient.name;
            }
		},
		filters: {
			lineBreak: text => text.replace(/\n/g, "<br/>"),
		},
        // mounted: {
        //
        // }
    }
</script>
